#import "../fragments/email-sequence-template-fragment.graphql"

query GetSharedEmailSequenceTemplates {
    emailSequenceTemplateCollection {
        sharedTemplates {
            ...EmailSequenceTemplate
        }
    }
}
